export const api = "/v1/example";

//auth
export const auth = {
  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_FAILED: "LOGIN_FAILED",
};
